import { Buildset } from "_/data/buildsets";
import { Uuid } from "_/types";

const simplifyBuildName = (name: string): string => {
  if (!name) return "";

  // Expected format: 2025.11.25.0-b0+g1192392--master
  const match = /^([0-9.]+)-(b\d+)\+g[0-9a-f]+--([A-Za-z0-9._-]+)$/i.exec(name);
  if (!match) return name;

  const [, baseVersion, buildNumber, branch] = match;
  // "release" branch get set when building a release candidate in meta-aon
  // keep main and master for older versions
  if (branch === "main" || branch === "master" || branch === "release") {
    return buildNumber === "b0" ? baseVersion : `${baseVersion}-${buildNumber}`;
  }

  return name;
};

export const formatBuildsetLabel = (
  buildset?: Pick<Buildset, "id" | "displayName" | "displayVersion">
): { value: string; fullName?: string; id?: Uuid } => {
  if (!buildset) return { value: "--", fullName: undefined, id: undefined };

  // Prefer the full displayVersion for branch/SHA context; fall back to displayName.
  const fullName = buildset.displayVersion || buildset.displayName || "";
  const simplified = simplifyBuildName(fullName);
  const value = simplified || "--";

  return { value, fullName, id: buildset.id };
};
